import {
  REQUEST_UNION, REQUEST_UNION_SUCCESS, REQUEST_UNION_FAILURE,
  REQUEST_EMPLOYEE_UNION, REQUEST_EMPLOYEE_UNION_FAILURE, REQUEST_EMPLOYEE_UNION_SUCCESS,
  REQUEST_PENSION, REQUEST_PENSION_SUCCESS, REQUEST_PENSION_FAILURE,
  REQUEST_BONUSES, REQUEST_BONUSES_SUCCESS, REQUEST_BONUSES_FAILURE,
} from 'constants/ActionTypes';

const initialState = {
  unions: [],
  unionLoading: false,
  unionError: null,
  employeeUnions: [],
  employeeUnionLoading: false,
  employeeUnionError: null,
  pensions: [],
  privatePensions: [],
  pensionLoading: false,
  pensionError: null,
  bonuses: [],
  bonusesLoading: false,
  bonusesError: null,
};

export default function EmployeePensionAndUnionReducer(state = initialState, action) {
  switch (action.type) {
    case REQUEST_UNION:
      return {
        ...state,
        unionLoading: true,
        unionError: null,
      };
    case REQUEST_UNION_SUCCESS:
      return {
        ...state,
        unionLoading: false,
        unions: action.unions,
      };
    case REQUEST_UNION_FAILURE:
      return {
        ...state,
        unionLoading: false,
        unionError: action.error,
      };
    case REQUEST_EMPLOYEE_UNION:
      return {
        ...state,
        employeeUnionLoading: true,
        employeeUnionError: null,
      };
    case REQUEST_EMPLOYEE_UNION_SUCCESS:
      return {
        ...state,
        employeeUnionLoading: false,
        employeeUnions: action.employeeUnions,
      };
    case REQUEST_EMPLOYEE_UNION_FAILURE:
      return {
        ...state,
        employeeUnionLoading: false,
        employeeUnionError: action.error,
      };
    case REQUEST_PENSION:
      return {
        ...state,
        pensionLoading: true,
        pensionError: null,
      };
    case REQUEST_PENSION_SUCCESS:
      return {
        ...state,
        pensionLoading: false,
        pensions: action.data.General,
        privatePensions: action.data.Private,
      };
    case REQUEST_PENSION_FAILURE:
      return {
        ...state,
        pensionLoading: false,
        pensionError: action.error,
      };
    case REQUEST_BONUSES:
      return {
        ...state,
        bonusesLoading: true,
        bonusesError: null,
      };
    case REQUEST_BONUSES_SUCCESS:
      return {
        ...state,
        bonusesLoading: false,
        bonuses: action.bonuses,
      };
    case REQUEST_BONUSES_FAILURE:
      return {
        ...state,
        bonusesLoading: false,
        bonusesError: action.error,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/EmployeePensionAndUnionReducer.js